// @module NVT.MyAssociateMulOrg.MyAssociateMulOrg
define('NVT.anuualupdateform.anuualupdateform.View'
,	[
	'nvt_anuualupdateform_myorganisation.tpl'
	
	,	'NVT.anuualupdateform.anuualupdateform.SS2Model'
	
	,	'Backbone'

	,	'Utils'

	,	'underscore'

	,	'Configuration'

	,  	'NVT.anuualupdateform.anuualupdateformBizProfile.View'

	,  	'NVT.anuualupdateform.anuualupdateformUpdateProfile.View'

	,  	'NVT.anuualupdateform.anuualupdateformUpdateContact.View'

	,  	'NVT.anuualupdateform.anuualupdateformAuthRepresantative.View'

	,	'NVT.anuualupdateform.anuualupdateformNewContact.View'

	,	'NVT.anuualupdateform.anuualupdateformAddress.View'

	, 	'Backbone.FormView'

	, 	'GlobalViews.Message.View'

	, 	'GlobalViews.Confirmation.View'

	, 	'jQuery'

	, 	'NVT.anuualupdateform.purpose_of_appointing_auth_rep.View'

	, 	'NVT.anuualupdateform.org_cont_instruction.View'
	
    ]
, function (
		nvt_myorganisation_myorganisation_tpl
	
	,	MyOrganisationSS2Model
	
	,	Backbone

	,	Utils

	,	_

	,	Configuration

	,	MyOrganisationBizProfileView

	,	MyOrganisationUpdateProfileView

	,	MyOrganisationUpdateContactView

	,	MyOrganisationAuthRepresantativeView

	,	MyOrganisationNewContactView

	,	MyAssociateMulOrgAddressView

	,   BackboneFormView

	,   MessageView

	,   GlobalViewsConfirmationView

	,   jQuery

	, 	purpose_of_appointing_auth_repView

	, 	org_cont_instructionView

)
{
    'use strict';

	// @class NVT.MyAssociateMulOrg.MyAssociateMulOrg.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_myorganisation_myorganisation_tpl

	,	title: Utils.translate('Annual Update Form')

	,	page_header: Utils.translate("Annual Update Form")
  
	,	initialize: function (options) {

		this.application = options.application;
		this.parentView = options.parentView;
		this.model = new MyOrganisationSS2Model();
			BackboneFormView.add(this);		
		var self = this;
			self.uen_validation = true;
			self.otp_container = false;
			self.org_details = false;

			self.tabname={};
			self.tabname.orginfo = true;
			self.tabname.meminfo = false;
			self.tabname.finaninfo = false;
			self.tabname.orgcont = false;
			self.tabname.authresp = false;	
			self.tabname.emailpref = false;
			self.isdisabledupdatesubcription = true;
		}

	,	getContactlistRespectiveOrg: function (compparam) {

			var self = this;
			this.models = new MyOrganisationSS2Model();
			self.organisationsContact = [];
			if(compparam)
			{
				this.models.fetch({async: false,data: {
				   'compparam': compparam  ,
				   'getmethod':'getcontactlist'
			   	}}).done(function(result) {
					if(result)
					{
						self.organisationsContact = result;
					}				 
				 });
			}

			return self.organisationsContact
			//self.render();
		}

	, 	forcetrimspace: function (e)
		{
			var el = e.target;
			var pos = el.selectionStart;
			el.value = el.value.trim();
			el.setSelectionRange(pos, pos);
		}

	,	events: {

			'input [name="uen"]': 'forcetrimspace',

			'input [name="email"]': 'forcetrimspace',

			'submit #isvalidateuen': 'saveTheForm',

			'keyup #uen': 'IsValidatedUen',

			'click [data-action="verify_otp_code"]': 'VerifyOtpCode',

			'click a[data-action="bizprofilerequest"]': 'BizProfileRequest',

			'click [data-action="updateprofile"]': 'updateprofile',

			'click [data-action="updatecontactprofile"]': 'updateContactProfile',

			'click #getpreviewdoc' : 'getFiledownloadByEvent' ,

			'click [data-action="add-new-auth-reps"]': 'addNewAuthReps',

			'click [data-action="myorgtabpaneldisplay"]': 'getmyorgtabpaneldisplay',

			'click [data-action="add-new-contact-inside-org"]': 'addNewContactInsideOrg',

			'click [data-action="select-mul-comp-infor"]': 'selectmulcompinfor',

			'click a[data-action="add-update-address"]': 'addUpdateAddress',

			'click [data-action="tryagain"]': 'tryagain',

			'click button[data-action="resendOtp"]' : 'SendOtpOnEmail',

			'click button[data-action="update-subscriptions"]' : 'dataActionUpdateSubscriptions',

			'click button[data-action="reset-subscriptions"]' : 'dataActionResetSubscriptions',

			'click #subscription-newsletter': 'dataActionSubscriptionNewsletter',

			'click [data-action="chkemailsubscriptiondetails"]': 'dataActionChkemailSubscriptionDetails',

			'click [data-action="purposeofappointauthrep"]': 'purposeofappointauthrep',

			'click [data-action="org_cont_instruction"]': 'openorgcontinstructionModel',

			'click [data-action="yearlydatasubmission"]': 'yearlydatasubmission',

			'click [data-action="alertDetailsConfirmedNoChanges"]': 'alertDetailsConfirmedNoChanges'
		}

	, 	alertDetailsConfirmedNoChanges: function (e) {
			var self = this;
			const getlay1 = self.application.layout;
			var view = new GlobalViewsConfirmationView({
				title: "Details confirmed - No Changes",
				body: Utils.translate('By checking this box, you confirm that all company information is accurate and up to date. Please review your details carefully, as this action cannot be reversed.'),
				class: 'hidden',
				autohide: true
			});
			getlay1.showInModal(view);
		}

	, 	yearlydatasubmission: function (e) {

			var self = this;
			var $yearlydatasubmission = jQuery('#yearlydatasubmission');

			if (!$yearlydatasubmission.is(":checked")) {
				return;
			}

			$yearlydatasubmission.prop('disabled', true);

			var FormESS2Model = new MyOrganisationSS2Model();
			FormESS2Model.fetch({
				data: {
					'getcontactid': self.otphasbeensend[0].orgId,
					'yearlydatasubmission': true,
					'getmethod': 'getyearlydatasubmission'
				}
			}).done(function (response) {
				if (response && response.yearlydatasubmissiondatachked == true) {
					self.data.yearlydatasubmissiondatachked = true;
					self.data.yearlydatasubmissiondataDate = response.yearlydatasubmissiondataDate;
					self.render();
				} else {
					$yearlydatasubmission.prop('checked', false).prop('disabled', false);
				}
			}).fail(function () {
				$yearlydatasubmission.prop('checked', false).prop('disabled', false);
			});
		}

	,	dataActionChkemailSubscriptionDetails : function(e){

			jQuery("#updatesubscriptions").prop('disabled', false);
			self.isdisabledupdatesubcription = false;
		}

	,	dataActionSubscriptionNewsletter:function(param){
		
			var self = this;
			var var_isdisabled = 'disabled';
			self.data.get_is_subscribed = false;
			if(jQuery('#subscription-newsletter').is(":checked")){
				var_isdisabled = '';
				self.data.get_is_subscribed = true;
			}

			for (let i = 0; i < self.data.get_cust_subscrip_list.length; i++) {
				self.data.get_cust_subscrip_list[i].isdisabled = var_isdisabled;
			}

			self.isdisabledupdatesubcription = false;
			self.render();
		}

	,	dataActionUpdateSubscriptions:function(e){
			var self = this;
			self.getemailsubdtls = [];
			if(jQuery('#subscription-newsletter').is(":checked")){
				self.globalsubscriptionstatus = true;

				jQuery("input[type='checkbox'].chk-email-subscription-details:checked").each(function () {
    				self.getemailsubdtls.push($(this).val());
				});
			}
			else{
				self.getemailsubdtls = [];
				self.globalsubscriptionstatus = false;
			}
			
			if(!self.nullCheck(this.data.email))
			{
				self.VerifyOtpCode();
				const global_view_message = new MessageView({
					message: Utils.translate("Your organisation does not currently have a general email address listed. Please update this information under the ‘Organisation Info’ tab to ensure your engagement preferences are correctly set."),
					type: 'error',
					closable: true
				});
				self.$('[data-type="alert-placeholder-message-email-preferences"]').append(
				global_view_message.render().$el.html());
			}
			else{
				var FormESS2Model = new MyOrganisationSS2Model();
				FormESS2Model.fetch({
					data: {
						'getemailsubdtls': JSON.stringify(self.getemailsubdtls),
						'getorgid':self.otphasbeensend[0].orgId,
						'globalsubscriptionstatus': self.globalsubscriptionstatus,
						'getmethod': 'postemailsubscription'
					}
				})
				.done(function (response) {
					self.getemailsubdtls = [];
					if(response.state == 'success'){
						self.isdisabledupdatesubcription = true;
						self.VerifyOtpCode();
						const global_view_message = new MessageView({
						message: Utils.translate(response.successMessage),
						type: 'success',
						closable: true
					});
					self.$('[data-type="alert-placeholder-message-email-preferences"]').append(
						global_view_message.render().$el.html());
					}
				});
			}			
		}

	,	dataActionResetSubscriptions:function(e){
			e.preventDefault();
			var self = this;
			self.VerifyOtpCode();
		}

	, 	saveTheForm: function (e) {

			var self = this,
				$target = jQuery(e.target),
				getfielddata = $target.serializeObject();

			if (getfielddata.uen) {
				getfielddata.uen = getfielddata.uen.trim();
				$target.find('[name="uen"]').val(getfielddata.uen);
			}
			if (getfielddata.email) {
				getfielddata.email = getfielddata.email.trim();
				$target.find('[name="email"]').val(getfielddata.email);
			}

			if (!getfielddata.uen) {
				self.showMessage('UEN number is required', 'error', 'uen');
				return false;
			}
			else if (!self.validateEmail(getfielddata.email.trim())) {
				self.showMessage('The email address used for login is required.', 'error', 'email');
				return false;
			}
			else if(self.IsValidatedUenList[0].membershiptype_text == '3')
			{
				self.showMessage("The UEN provided is not eligible for Annual update. Please contact to update@sbf.org.sg for further clarification" , 'error', 'uen');
				return false;
			}
			else {
				var promise = BackboneFormView.saveForm.apply(this, arguments);

				return promise && promise.then
				(
					function (responce) {
						if (responce[0].successMessage) {
							self.showMessage(responce[0].successMessage, 'success');
							self.otphasbeensend = responce;
							self.uen_validation = false;
							self.otp_container = true;
							self.render();
						}
						else {
							const getlay1= self.application.layout;		
							var view = new GlobalViewsConfirmationView({
								title: "Invalid",
								body: Utils.translate(responce[0].errorMessage),
								class:'hidden',
								autohide: true
							});
							getlay1.showInModal(view);
							//self.showMessage(responce[0].errorMessage, 'error');
							return false;
						}

					}
				);
			}

		}

	, 	showMessage: function (message, type, field) {
			jQuery('.global-views-message-error').remove();
			jQuery('.global-views-message-success').remove();

			var messageView = new MessageView
				({
					message: message
					, type: type
					, closable: type == 'error' ? true : false
				});
			if (typeof field !== 'undefined') {
				this.options.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
			}
			else if (type == 'error') {
				this.options.application.getLayout().$('form').append(messageView.render().$el);
			}
			else {
				this.options.application.getLayout().$('form').append(messageView.render().$el);
			}
		}

	,	tryagain:function(e){
			var self = this;
			self.otphasbeensend = '';			
			self.uen_validation = true;
			self.otp_container = false;
			self.org_details = false;
			self.render();
		}

	, 	IsValidatedUen: function (e) {
			e.preventDefault();
			
			var self = this;
			var getcurrentvalue = jQuery('#uen').val().trim();
			if (getcurrentvalue) {
				var FormESS2Model = new MyOrganisationSS2Model();
				FormESS2Model.fetch({
					data: {
						'uen_no': getcurrentvalue,
						'getmethod': 'checkUENnumberIsValid'
					}
				})
					.done(function (response) {

						if (response.length === 0) {
							self.showMessage("The UEN you entered was not found in our records. Please contact to update@sbf.org.sg for further clarification", 'error', 'uen');
						}
						else {
							self.IsValidatedUenList = response;
							jQuery('.global-views-message-error').remove();
							for (var n = 0; n < response.length; n++) {
								jQuery("input[name='organisationname']").val(response[0].name);
							}
						}
					});
			}
		}

	, 	VerifyOtpCode : function(e)
			{
				var self = this;
				var otpvode = '';
					jQuery(".otp-inputs > input").each(function() {
						if( $(this).val()){
							otpvode += $(this).val();
						}
					});
					
				otpvode = otpvode == '' ? self.aufid : otpvode;
				if(otpvode){
					self.aufid = otpvode
					this.models = new MyOrganisationSS2Model();
					this.models.fetch({async: false,data: {
						'getmethod':'VerifyOtpCode',
						'otpvode':otpvode,
						'contactId': self.otphasbeensend[0].contactId || '',
						'orgid': self.otphasbeensend[0].orgId || '',
						'orgname': self.otphasbeensend[0].orgname || '',
					},
					}).done(function(result) {
							if(result.responce_VerifyOtpCode == true)
								{
									self.otp_container = false;
									self.org_details = true;
									self.data = result.getOrgdetails[0];
									self.organisationsContact = self.getContactlistRespectiveOrg(self.otphasbeensend[0].orgId);
									var getpendingList = self.getlistPendingReview(self.otphasbeensend[0].orgId);
									if(self.data && self.data.isAuthRespTabShowing)
									{
										var getAuthRepresentative = self.getlistAuthRepresentative(self.otphasbeensend[0].orgId);
									}
									self.render();
								}
								else{
									self.org_details = false;
									const getlay1= self.application.layout;		
									var view = new GlobalViewsConfirmationView({
										title: "OTP",
										body: Utils.translate('The verification code that you have entered is incorrect. Please try again.'),
										class:'hidden',
										autohide: true
									});
									getlay1.showInModal(view);
								}
							
						});
				}
				else{
					const getlay1= self.application.layout;		
					var view = new GlobalViewsConfirmationView({
						title: "OTP",
						body: Utils.translate('The verification code that you have entered is incorrect. Please try again.'),
						class:'hidden',
						autohide: true
					});
					getlay1.showInModal(view);
				}
			}

	,	selectmulcompinfor : function(e)
		{
			//var id= jQuery("#MultipleCompany").val()
			var id= jQuery(e.currentTarget).data('id');
			if(id){
				var newurlopen = SC.ENVIRONMENT.siteSettings.touchpoints.customercenter+"#/sbfmyassociatemulorg?accosiate="+id;
				window.open(
					newurlopen,
					'_blank' 
				  );
			}
		}

	, 	addUpdateAddress: function (e)
		{
		  e.preventDefault();
		  var self=this;
		  var model = new MyOrganisationSS2Model();
		  var application = this.application;
		  var Layout = application.getLayout();

		  var id= jQuery(e.target).data('id');
			var view = new MyAssociateMulOrgAddressView({
				application: application,
				model: model,
				profile:self.data || '',
				cutomuparams: self.otphasbeensend[0].orgId || ''
		  });				
		  Layout.showInModal(view);
			view.model.on('sync', function (model) {      
				setTimeout(function() {
					self.VerifyOtpCode(model);
				}, 2000);
			});
		}

		, 	SendOtpOnEmail: function () {
			var self = this;
			if (self.otphasbeensend[0].contactId ) {
				var FormESS2Model = new MyOrganisationSS2Model();
					FormESS2Model.fetch({
					data: {
						'param': self.otphasbeensend[0].contactId || '',
						'orgname': self.otphasbeensend[0].orgname || '',
						'getmethod': 'SendOtpOnEmail'
					}
				}).done(function (response) {
					self.render();
				});
			}
		}

	,	renderModelset:function(parma)
		{
			var self= this;
			self.uen_validation = false;
			self.otp_container = false;
			self.org_details = true;

			this.models = new MyOrganisationSS2Model();
			this.models.fetch({async: false,data: {
				'compparam': parma  ,
				'getmethod':'getMyOrganisationDetails'
					},
					}).done(function(result) {

				 if(result)
				 {
					 self.data = result[0];
				 }				 

				 self.organisationsContact = self.getContactlistRespectiveOrg(parma);
				 var getpendingList = self.getlistPendingReview(parma);
				 if(self.data && self.data.isAuthRespTabShowing)
				 {
					 var getAuthRepresentative = self.getlistAuthRepresentative(parma);
				 }
				 self.render();
			  });
		}

	,	getmyorgtabpaneldisplay : function(e)
		{
			e.preventDefault();
			var self = this;
			var parmval =jQuery(e.target).data('tabname');
				self.showtabpanel = parmval || '';

			if(parmval == 'meminfo' || parmval == 'orgcont' || parmval == 'authresp' || parmval == 'emailpref')
			{
				jQuery(".getlistpendingreview").hide()
			}
			else{
				jQuery(".getlistpendingreview").show()
			}

			if(parmval == 'orgcont')
			{
				self.getContactlistRespectiveOrg(self.otphasbeensend[0].orgId);
			}

			self.tabname.orginfo = parmval === 'orginfo';
			self.tabname.meminfo = parmval === 'meminfo';
			self.tabname.finaninfo = parmval === 'finaninfo';
			self.tabname.orgcont = parmval === 'orgcont';
			self.tabname.authresp = parmval === 'authresp';
			self.tabname.emailpref = parmval === 'emailpref';
		}	

	, 	getFiledownloadByEvent: function(e)
        {
            e.preventDefault();
			var self = this;
			var parmval =jQuery(e.target).data('link');
			if(parmval !='' || parmval !=null || parmval !=undefined){
			var _getparm=document.createElement('a');
					_getparm.href=window.location.origin +parmval;
					_getparm.target="_blank";
					_getparm.download="downloadfile";
					_getparm.click();    
			} else {
				alert('Invalid, File Not Found.');
			}            
        }  

	,	getContactProfile: function (paramval) {

			var self = this;
			this.models = new MyOrganisationSS2Model();
				self.getContactProfileData = []

			if(self.nullCheck(paramval))
			{
				this.models.fetch({async: false,data: {
				   'compparam': paramval  ,
				   'getmethod':'ContactListSearching'
			   	}}).done(function(result) {
					if(result &&  result.length > 0)
					{
						self.getContactProfileData = result[0];
					}					
				});
			}

			return self.getContactProfileData
		}

	,	getlistPendingReview: function (accosiate) {

			var self = this;
			this.models = new MyOrganisationSS2Model();
			self.getlistPendingReviews = []
			if(accosiate)
			{
				this.models.fetch({async: false,data: {
				   'getmethod':'getPendingReview',
				   'accosiate' :accosiate
			   	}}).done(function(result) {
					if(result &&  result.length > 0)
					{
						self.getlistPendingReviews = result;
					}					
				});
			}

			return self.getlistPendingReviews
		}

	,	getlistAuthRepresentative: function (accosiate) {

			var self = this;
			this.models = new MyOrganisationSS2Model();
				self.getAuthRepresentativelist = []
			
			if(accosiate)
			{
				this.models.fetch({async: false,data: {
				   'getmethod':'getlistAuthRepresentative',
				   'accosiate' :accosiate
			   	}}).done(function(result) {
					if(result &&  result.length > 0)
					{
						self.getAuthRepresentativelist = result;
					}					
				});
			}

			return self.getAuthRepresentativelist
		}

	, 	validateEmail: function (email) {

			var self = this;
			var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
			return re.test(email);
		}

	, 	addNewAuthReps: function (e)
		{
			e.preventDefault();
			var self=this;
			var model = new MyOrganisationSS2Model();
			var application = this.application;
			var Layout = application.getLayout();
  
			var id= jQuery(e.target).data('id');
			  var view = new MyOrganisationAuthRepresantativeView({
				  application: application,
				  model: model,
				  compname:self.data.altname || '',
				  jobtitle:self.data.getJobTitle || '',
				  internalid: self.otphasbeensend[0].orgId || '',
				  cutomuparamsemail: self.model.get('email')|| '',

			});				
			Layout.showInModal(view);
			  view.model.on('sync', function (model) {      
				//self.VerifyOtpCode(model);
				setTimeout(function() {
					self.VerifyOtpCode(model);
				}, 2000);
			  });
		}

	, 	addNewContactInsideOrg: function (e)
		{

 		e.preventDefault();
		  var self=this;
		 // var id = jQuery(e.currentTarget).data('id')
		  var getContactProfileData = '';// self.getContactProfile(id);
		  var model = new MyOrganisationSS2Model();
		  var application = this.application;
		  var Layout = application.getLayout();
			
		  var view = new MyOrganisationNewContactView({
				application: application,
				model: model,
				profile: self.getContactProfileData || '',
				contactCategory : self.organisationsContact.length > 0 ? self.organisationsContact[0].getdesglist : '',
				accosiate_id: self.otphasbeensend[0].orgId || ''
		  });				
		  Layout.showInModal(view);
			view.model.on('sync', function (model) {      
				//self.VerifyOtpCode(model);
				setTimeout(function() {
					self.VerifyOtpCode(model);
				}, 2000);
			});
		}

	, 	updateContactProfile: function (e)
		{
		  e.preventDefault();
		  var self=this;
		  var id = jQuery(e.currentTarget).data('id')
		  var getContactProfileData =  self.getContactProfile(id);
		  var model = new MyOrganisationSS2Model();
		  var application = this.application;
		  var Layout = application.getLayout();

		  var view = new MyOrganisationUpdateContactView({
				application: application,
				model: model,
				profile: self.getContactProfileData || ''
		  });				
		  Layout.showInModal(view);
			view.model.on('sync', function (model) {      
				//self.VerifyOtpCode(model);
				setTimeout(function() {
					self.VerifyOtpCode(model);
				}, 2000);
			});
		}
		
	, 	BizProfileRequest: function (e)
		{
		  e.preventDefault();
		  var self=this;
		  var model = new MyOrganisationSS2Model();
		  var application = this.application;
		  var Layout = application.getLayout();

		  var id= jQuery(e.target).data('id');
			var view = new MyOrganisationBizProfileView({
				application: application,
				model: model,
				profile:self.otphasbeensend[0].contactName || '',
				cutomuparams:self.otphasbeensend[0].orgId || '',
				cutomuparamsemail: self.model.get('email')|| '',

		  });				
		  Layout.showInModal(view);
			view.model.on('sync', function (model) {      
				//self.VerifyOtpCode(model);
				setTimeout(function() {
					self.VerifyOtpCode(model);
				}, 2000);
			});
		}

	,	nullCheck :	function nullCheck(value)
		{
			var self=this;

			if (value != null && value != '' && value != undefined)
				return true;
			else
				return false;
		}

	,	updateprofile: function updateprofile(e) {
		e.preventDefault();
		var self=this;
		var gettext=false,getdwn=false,gettextarea =false;
		var getinputss = jQuery(e.currentTarget).data('inputss');
			if(getinputss == 'textarea'){

				gettextarea = true;
			} 
			else if(getinputss == 'dwn')
			{
				getdwn = true;
			}
			else 
			{
				gettext = true;
			}

		var getfieldvalueid =jQuery(e.currentTarget).data('type');
		var getlblName = jQuery("#lblName_"+getfieldvalueid).text();
		var getfieldvalue = jQuery("#getlabelvalue_"+getfieldvalueid).text();
		var getinternalid = jQuery(e.currentTarget).data('id');
		var accosiate_id = self.otphasbeensend[0].orgId || ''

		if(self.nullCheck(getlblName) && self.nullCheck(getfieldvalueid) && self.nullCheck(accosiate_id)){

			var getjsonrequest= {
				'getlblName': getlblName || '',
				'getfieldvalueid': getfieldvalueid || '',
				'getfieldvalue': getfieldvalue || '',
				'getinternalid': accosiate_id ? accosiate_id : getinternalid,
				'gettextarea' : gettextarea,
				'getdwn' : getdwn,
				'gettext' : gettext,
				'getinputss':getinputss
			}

			var model = new MyOrganisationSS2Model();
			var application = this.application;
			var Layout = application.getLayout();
			var UpdateProfileViewview = new MyOrganisationUpdateProfileView({
					application: application,
					model: model,
					getjsonrequest:getjsonrequest || ''
				});				
			Layout.showInModal(UpdateProfileViewview);
				UpdateProfileViewview.model.on('sync', function (model) {     
					//self.VerifyOtpCode(model);
					setTimeout(function() {
						self.VerifyOtpCode(model);
					}, 2000);
			});
		}	
		}

			, purposeofappointauthrep: function (e) {
				e.preventDefault();
				var self = this;
				self.openPurposeOfAppointAuthRepModal();
			}

			, openPurposeOfAppointAuthRepModal: function () {
				var self = this;
				var model = new MyOrganisationSS2Model();
				var application = this.application;
				var Layout = application.getLayout();

				var view = new purpose_of_appointing_auth_repView({
					application: application,
					model: model,
				});
				Layout.showInModal(view);
			}


			, openorgcontinstructionModel: function (e) {

				e.preventDefault();
				var self = this;
				var model = new MyOrganisationSS2Model();
				var application = this.application;
				var Layout = application.getLayout();

				var view = new org_cont_instructionView({
					application: application,
					model: model,
				});
				Layout.showInModal(view);

			}

	,	bindings: {

		}

	,	dateFormatConversion :function(paramdate)
		{
			var self = this;				
			var parts = paramdate.split('/');
			if(paramdate && parts.length > 1){
				let date = new Date(parts[2], parts[1] - 1, parts[0]) 
				let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
				let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
				let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
				let newDateFormat = day+'-' +month +'-'+year;
				return newDateFormat
			}
			return paramdate
		}

	// ,	showContent: function() {

	// 		this.defaultbillingAddress = this.addresses.findWhere({ defaultbilling: 'T' });
	// 		this.defaultbillingAddress && this.defaultbillingAddress.on('change', this.showContent, this);


	// 		this.defaultshippingAddress = this.addresses.findWhere({ defaultshipping: 'T' });
	// 		this.defaultshippingAddress && this.defaultshippingAddress.on('change', this.showContent, this);
			
	// 		return this.application.getLayout().showContent(this);
	// 	}


	,	getAddressListDetails : function(addr)
		{
			var self = this;	
			var retrunAddress = '';
			if(addr){
			var countries = Configuration.get('siteSettings.countries', []);
			var country_object = countries[addr.get('country')];
			var country = country_object ? country_object.name : addr.get('country');
			var state_object = country_object && country_object.states ? _.findWhere(
						  countries[addr.get('country')].states,
						  {
							  code : addr.get('state')
						  }
					  ) : null;
			var state = state_object ? state_object.name : addr.get('state');

				retrunAddress = {
					id:addr.get('internalid') || '',
					fullname: addr.get('fullname') || '',
					addr1: addr.get('addr1') || '',
					addr2 : addr.get('addr2') || '',
					addr3:addr.get('addr3') || '',
					city : addr.get('city') || '',
					state:state,
					country:country,
					zip:addr.get('zip') || '', 
					phone: addr.get('phone') || '', 
				}
			}
			
			return retrunAddress
		}

	,	parseDateDDMMYYYY:function(dateStr){
			var self = this;
			const [day, month, year] = dateStr.split('/');
  			return new Date(+year, +month - 1, +day); // months are 0-based
		}

	,	isshowingEmailPreferencesTab:function(){
		
			var self = this;
			var returnFlag = false;
			const dateStr1 = new Date().toLocaleDateString('en-GB');
			const dateStr2 = SC.CONFIGURATION.anuualupdateform.engagementpreferencesenddate;

			if(self.nullCheck(dateStr2)){
				const date1 = self.parseDateDDMMYYYY(dateStr1);
				const date2 = self.parseDateDDMMYYYY(dateStr2);
				if (date2 >= date1) {
					returnFlag = true;
				} else {
					returnFlag = false;
				}
			}

			return returnFlag
		}

		//@method getContext @return NVT.MyOrganisation.MyOrganisation.View.Context
	,	getContext: function getContext()
		{
			//@class NVT.MyOrganisation.MyOrganisation.View.Context
			var self = this;
			let isMyOrgHovertoggle = SC.CONFIGURATION.MyOrganisationHoverParticipant || '';

			if(this.data && this.data.memdateofinc){
				this.data.memdateofinc = self.dateFormatConversion(this.data.memdateofinc);
			}

			if(this.data && this.data.approvaldate){
				this.data.approvaldate = self.dateFormatConversion(this.data.approvaldate);
			}

			if(this.data && this.data.getCurrentRoleId == true){
				isMyOrgHovertoggle = SC.CONFIGURATION.MyOrganisationHover || '';
			}
		
			this.defaultbilladdr  = this.defaultbillingAddress ? self.getAddressListDetails(this.defaultbillingAddress) : '';

			this.defaultshippaddr = this.defaultshippingAddress ? self.getAddressListDetails(this.defaultshippingAddress) : '';

			//var ams_membershipid = this.data.ams_membershipid || '';

			var getpendingList = self.getlistPendingReviews || [];
			var getAuthRepresentative = self.getAuthRepresentativelist || [];

			var	isAddNewRequest = getAuthRepresentative ? getAuthRepresentative.filter(function(prceauthrep) {
				return prceauthrep.status == true
			}) : [];

			var	isgetpendingList = getpendingList ? getpendingList.filter(function(prce) {
					return prce.status == true
				}) : [];

			var getauthreplist = this.organisationsContact ? this.organisationsContact.filter(function(authrep) {
					return authrep.getauthorisrep == true
				}) : [];

			var getOrgContlist = this.organisationsContact ? this.organisationsContact.filter(function(authrep) {
					return authrep.getauthorisrep != true
				}) : [];

				let _basedcapitalamt = this.data ? Utils.formatCurrency(parseFloat(this.data.basedcapitalamt),' ') : '' ;
				let _paidupcapital = this.data ? Utils.formatCurrency(parseFloat(this.data.paidupcapital),' ') : '';

			return {
				data : this.data || '',
				
				organisationsContact :  getOrgContlist || '', //this.organisationsContact || '',

				defaultbilladdr : this.defaultbilladdr || '',

				defaultshippaddr : this.defaultshippaddr || '',

				getmyorghover : isMyOrgHovertoggle,

				compinternalid : this.compinternalid || '',

				getlistPendingReview : getpendingList.length > 0 ,

				getpendingList : getpendingList ,

				isgetpendingList : isgetpendingList.length > 0 ,

				getAuthRepresentative : self.getAuthRepresentativelist,

				isAddNewRequest : isAddNewRequest.length > 0 ,

				getauthreplist :  getauthreplist,

				basedcapitalamt : _basedcapitalamt || '',

				paidupcapital : _paidupcapital || '' ,

				outstandingPayment :  this.isoutstandingbalance || false,

				BizFileHeaderCaption :  SC.CONFIGURATION.MyOrganisation.BizFileHeaderCaption || '',

				otphasbeensend : self.otphasbeensend || '',

				uen_validation : self.uen_validation ,

				otp_container: self.otp_container,

				org_details: self.org_details,

				showtabpanel : self.showtabpanel || '',

				tabname:self.tabname,

				isdisabledupdatesubcription : self.isdisabledupdatesubcription === true,

				isengagementpreferencesenddate : self.isshowingEmailPreferencesTab(),

				getemailsubscriptionstitle : SC.CONFIGURATION.anuualupdateform.emailsubscriptionstitle || '',

				stepbystphelpguide: SC.CONFIGURATION.anuualupdateform.stepbystphelpguide || '',

				arAppointmentFormUrl: SC.CONFIGURATION.anuualupdateform.arAppointmentFormUrl || '',

				isisyearlydatasubmissiondetailsconfirmation: SC.CONFIGURATION.anuualupdateform.isyearlydatasubmissiondetailsconfirmation === true,

				//downloadPDFURL: _.getDownloadPdfUrl({asset: 'mem-org-details', id: ams_membershipid})

			};
		}
	});
});
